import React from 'react'

const FooterContainer = () => {
  return (
    <div className='FooterContainer'>
      Hope you guys would like my code style.©
    </div>
  )
}

export default FooterContainer
